import React, { useEffect, useState } from "react";
import { Box, FormControl, useMediaQuery } from "native-base";
import InputErrorMessage from "../inputErrorMessage";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

const TimeInputField = ({
  label = "",
  name = "date",
  width = "auto",
  defaultValue = "",
  isInvalid = false,
  isDisabled = false,
  errorMessage = "Enter details",
  onChange = () => {},
  important = false,
  transparent = false,
  ind = 0,
}) => {
  const [value, setValue] = useState(defaultValue);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  useEffect(() => {
    if (defaultValue) setValue(defaultValue);
    else setValue("");
  }, [defaultValue]);

  // useEffect(() => {
  //   flatpickr("#timePicker", {
  //     enableTime: true,
  //     noCalendar: true,
  //     dateFormat: "H:i",
  //     minuteIncrement: 1,
  //     onChange: function (selectedDates, dateStr) {
  //       const syntheticEvent = {
  //         target: {
  //           value: dateStr,
  //         },
  //       };
  //       handleTimeChange(syntheticEvent);
  //     },
  //   });
  // }, []);

  const handleTimeChange = (e) => {
    // setValue(e.target.value);
    // onChange(e, name, ind);
    setValue(e.target.value);
    onChange(e, name, ind);
  };

  const preventTyping = (e) => {
    e.preventDefault();
  };

  return (
    <Box>
      <FormControl isInvalid={isInvalid} isDisabled={isDisabled} w={width}>
        {label && (
          <FormControl.Label>
            {label} {important && <span>*</span>}
          </FormControl.Label>
        )}
        <div className="custom-date-input-container">
          {/* <input
            name={name}
            value={value}
            type="text"
            id="timePicker"
            placeholder="Select Time"
            className={`custom-date-input custom-time-input ${
              value ? "has-value" : ""
            } ${isInvalid ? "invalid-input" : ""} ${
              MobileWindow && !value && "mobile-input-date-field"
            }`}
            onChange={handleTimeChange}
            disabled={isDisabled}
            onKeyDown={preventTyping}
            style={{ backgroundColor: transparent && "transparent" }}
          /> */}
          <input
            name={name}
            value={value}
            type="time"
            className={`custom-date-input custom-time-input ${
              value ? "has-value" : ""
            } ${isInvalid ? "invalid-input" : ""} ${
              MobileWindow && !value && "mobile-input-date-field"
            }`}
            onChange={handleTimeChange}
            disabled={isDisabled}
            onKeyDown={preventTyping}
            style={{ backgroundColor: transparent && "transparent" }}
          />
          {MobileWindow && (
            <div className="date-input-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            </div>
          )}
        </div>
        {isInvalid && <InputErrorMessage errorMessage={errorMessage} />}
      </FormControl>
    </Box>
  );
};

export default TimeInputField;

// import React, { useState } from "react";
// import { Box, FormControl, useMediaQuery } from "native-base";
// import InputErrorMessage from "../inputErrorMessage";
// import { MOBILE_VIEW_WIDTH } from "../../utils/screens";

// const TimeInputField = ({
//   label = "",
//   name = "date",
//   width = "auto",
//   defaultValue = "",
//   isInvalid = false,
//   isDisabled = false,
//   errorMessage = "Enter details",
//   onChange = () => {},
//   important = false,
//   transparent = false,
//   ind = 0,
// }) => {
//   const [value, setValue] = useState(defaultValue);
//   const [MobileWindow] = useMediaQuery({
//     maxWidth: MOBILE_VIEW_WIDTH,
//   });

//   const handleTimeChange = (e) => {
//     setValue(e.target.value);
//     onChange(e, name, ind);
//   };

//   const clearInput = () => {
//     setValue("");
//     onChange({ target: { value: "" } }, name, ind);
//   };

//   const preventTyping = (e) => {
//     e.preventDefault();
//   };

//   return (
//     <Box>
//       <FormControl isInvalid={isInvalid} isDisabled={isDisabled} w={width}>
//         {label && (
//           <FormControl.Label>
//             {label} {important && <span>*</span>}
//           </FormControl.Label>
//         )}
//         <div
//           className="custom-date-input-container"
//           style={{ position: "relative" }}
//         >
//           <input
//             name={name}
//             value={value}
//             type="time"
//             className={`custom-date-input custom-time-input ${
//               value ? "has-value" : ""
//             } ${isInvalid ? "invalid-input" : ""} ${
//               MobileWindow && !value && "mobile-input-date-field"
//             }`}
//             onChange={handleTimeChange}
//             disabled={isDisabled}
//             onKeyDown={preventTyping}
//             style={{ backgroundColor: transparent && "transparent" }}
//           />
//           {value && (
//             <button
//               type="button"
//               onClick={clearInput}
//               className="clear-button"
//               style={{
//                 position: "absolute",
//                 right: "10px",
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 borderRadius: "50%",
//                 background: "rgb(215 209 209 / 50%)",
//                 backdropFilter: "blur(50px)",
//                 border: "none",
//                 cursor: "pointer",
//                 fontWeight: "900",
//                 fontSize: "12px",
//                 color: "rgb(254 4 4)",
//               }}
//             >
//               ✕
//             </button>
//           )}
//           {MobileWindow && (
//             <div className="date-input-svg">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="18"
//                 height="18"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
//                 <line x1="16" y1="2" x2="16" y2="6" />
//                 <line x1="8" y1="2" x2="8" y2="6" />
//                 <line x1="3" y1="10" x2="21" y2="10" />
//               </svg>
//             </div>
//           )}
//         </div>
//         {isInvalid && <InputErrorMessage errorMessage={errorMessage} />}
//       </FormControl>
//     </Box>
//   );
// };

// export default TimeInputField;
